module.exports = __webpack_public_path__ + "static/img/ggtffb.865575c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/ym/ggtffb.png
// module id = 3N8q
// module chunks = 1